import { api } from './api';

const NEURO_BASE = '/neuro';

const unwrap = (res) => res.data?.data ?? res.data;

export const neuroService = {
  getQuestions: async () => unwrap(await api.get(`${NEURO_BASE}/questions`)),

  getConsent: async () => unwrap(await api.get(`${NEURO_BASE}/consent`)),

  getKidStatus: async (kidId) => unwrap(await api.get(`${NEURO_BASE}/kids/${kidId}/status`)),

  startEvaluation: async ({ kid_id, consent_version_id }) =>
    unwrap(await api.post(`${NEURO_BASE}/evaluations`, { kid_id, consent_version_id })),

  saveAnswers: async (evaluationId, { answers, current_position }) =>
    unwrap(await api.patch(`${NEURO_BASE}/evaluations/${evaluationId}/answers`, {
      answers,
      current_position,
    })),

  submitEvaluation: async (evaluationId) =>
    unwrap(await api.post(`${NEURO_BASE}/evaluations/${evaluationId}/submit`)),

  getResult: async (evaluationId) =>
    unwrap(await api.get(`${NEURO_BASE}/evaluations/${evaluationId}`)),

  deleteEvaluation: async (evaluationId) => {
    await api.delete(`${NEURO_BASE}/evaluations/${evaluationId}`);
  },

  sendResultsEmail: async (evaluationId) =>
    unwrap(await api.post(`${NEURO_BASE}/evaluations/${evaluationId}/send-email`)),

  downloadPdf: async (evaluationId) => {
    const axios = (await import('axios')).default;
    const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.baoubab.space';
    const token = localStorage.getItem('access_token');
    const res = await axios.get(`${API_BASE_URL}/api${NEURO_BASE}/evaluations/${evaluationId}/pdf`, {
      responseType: 'blob',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return res.data;
  },

  joinClassSession: async ({ session_code, kid_id }) =>
    unwrap(await api.post(`${NEURO_BASE}/class-sessions/join`, { session_code, kid_id })),

  getEstablishmentStats: async (establishmentId) =>
    unwrap(await api.get(`/establishments/${establishmentId}/stats`)),

  getMyEstablishments: async () => unwrap(await api.get('/establishments')),

  createClassSession: async (establishmentId, name) =>
    unwrap(await api.post(`/establishments/${establishmentId}/class-sessions`, { name })),

  getClassSessions: async (establishmentId) =>
    unwrap(await api.get(`/establishments/${establishmentId}/class-sessions`)),
};

export default neuroService;
